import type React from 'react'

interface InfoCircleIconProps {
  size?: number | string
  color?: string
  className?: string
}

const InfoCircleIcon: React.FC<InfoCircleIconProps> = ({ size = 20, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={'Info Circle Icon'}
      role="img"
    >
      <path
        d="M17.7096 9.99935C17.7096 5.76119 14.2395 2.29102 10.0013 2.29102C5.76315 2.29102 2.29297 5.76119 2.29297 9.99935C2.29297 14.2375 5.76315 17.7077 10.0013 17.7077C14.2395 17.7077 17.7096 14.2375 17.7096 9.99935ZM18.9596 9.99935C18.9596 14.9279 14.9298 18.9577 10.0013 18.9577C5.07279 18.9577 1.04297 14.9279 1.04297 9.99935C1.04297 5.07084 5.07279 1.04102 10.0013 1.04102C14.9298 1.04102 18.9596 5.07084 18.9596 9.99935Z"
        fill={color}
      />
      <path
        d="M9.375 10.8327V6.66602C9.375 6.32084 9.65482 6.04102 10 6.04102C10.3452 6.04102 10.625 6.32084 10.625 6.66602V10.8327C10.625 11.1779 10.3452 11.4577 10 11.4577C9.65482 11.4577 9.375 11.1779 9.375 10.8327Z"
        fill={color}
      />
      <path
        d="M10.0047 12.5L10.0902 12.5041C10.5104 12.5468 10.8381 12.9019 10.8381 13.3333C10.8381 13.7648 10.5104 14.1199 10.0902 14.1626L10.0047 14.1667H9.9974C9.53716 14.1667 9.16406 13.7936 9.16406 13.3333C9.16406 12.8731 9.53716 12.5 9.9974 12.5H10.0047Z"
        fill={color}
      />
    </svg>
  )
}

export default InfoCircleIcon
